import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface IPartsDistributorFormMeta {
    activePartsDistributor: FormInputMeta;
    partTape1Active: FormInputMeta;
    partTape2Active: FormInputMeta;
    partTape3Active: FormInputMeta;
    partTape4Active: FormInputMeta;

}

const partsDistributorFormMeta = {} as IPartsDistributorFormMeta;

partsDistributorFormMeta.activePartsDistributor = {
    name: "activePartsDistributor",
    type: "checkbox",
    label: "Distributeur Pièces Actif",
    placeholder: "",
    validation: yup.boolean()
};

partsDistributorFormMeta.partTape1Active = {
    name: "partTape1Active",
    type: "checkbox",
    label: "Cassette de Pièce 1 Actif",
    placeholder: "",
    validation: yup.boolean()
};

partsDistributorFormMeta.partTape2Active = {
    name: "partTape2Active",
    type: "checkbox",
    label: "Cassette de Pièce 2 Actif",
    placeholder: "",
    validation: yup.boolean()
};

partsDistributorFormMeta.partTape3Active = {
    name: "partTape3Active",
    type: "checkbox",
    label: "Cassette de Pièce 3 Actif",
    placeholder: "",
    validation: yup.boolean()
};

partsDistributorFormMeta.partTape4Active = {
    name: "partTape4Active",
    type: "checkbox",
    label: "Cassette de Pièce 4 Actif",
    placeholder: "",
    validation: yup.boolean()
};


export default partsDistributorFormMeta;